export default __webpack_public_path__ + "static/assets/2564c825a5cfca158a3bf3b2edf2f616.svg";